// Config file to manage environment variables

interface StripeConfig {
  publishableKey: string;
  secretKey: string;
  webhookSecret: string;
  priceId: string;
}

// For client-side access - use environment variables if available, otherwise use defaults
export const stripeConfig: StripeConfig = {
  publishableKey: process.env.VITE_STRIPE_PUBLISHABLE_KEY || 'pk_live_51RHxWrCGRvOnj8s8TB5dPRssfCW0r5G8Ux01yutLHvLNx11b3sdsrOPDo2R7ILbOJZCNeCXDfgJu4tb7G1iHo7U00G8BCLSsh',
  secretKey: process.env.VITE_STRIPE_SECRET_KEY || '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',
  webhookSecret: process.env.VITE_STRIPE_WEBHOOK_SECRET || 'whsec_WEkLFhtGEvRMUVw0K1j67uCpQncdWKdi',
  priceId: process.env.VITE_STRIPE_PRICE_ID || 'price_1RPzN4CGRvOnj8s8cYuHI9Bk'
};

export default {
  stripe: stripeConfig
}; 